import { z } from "zod";

export const ReservationReportFilterSchemaV4 = z.object({
    property_id: z.string(),
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    base_on: z.literal("created_reservation"), // Hanya menerima satu nilai ini
});

export type ReservationReportFilterV4Type = z.infer<typeof ReservationReportFilterSchemaV4>;